import * as v from 'valibot';
import { CustomFieldValueParamSchema, SearchTermSchema, TrimmedSearchTermSchema } from '~/schemas';

export const ProductPosFilterSchema = v.object({
	hasPosm: v.boolean(),
	productTypeCustomFieldValues: v.array(CustomFieldValueParamSchema),
	posTypeId: v.array(v.number()),
	regionId: v.array(v.number()),
	areaId: v.array(v.number()),
	filter: v.object({
		id: v.array(v.number()),
		value: v.array(v.string()),
	}),
	searchTerm: TrimmedSearchTermSchema,
});

export const ProductProductTypeFilterSchema = v.object({
	posZoneId: v.array(v.number()),
	productCategory: v.array(v.number()),
	productClassId: v.nullable(v.number()),
	searchTerm: SearchTermSchema,
	customFieldValues: v.array(CustomFieldValueParamSchema),
});
